import React, { Component } from "react";
import { message, Row, Col, Select, Alert } from "antd";
import { ColorPicker } from "antd5";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputItem,
  ButtonItem,
  ErrorItem,
  SwitchItem,
  MensajeError,
} from "../../../../../Components/Items";
import { PlusOutlined, DeleteOutlined, LockOutlined } from "@ant-design/icons";
import { ICONOS_ETAPA, OPCIONES_ICONO_ETAPA } from "../etapaVisual.utils";

const { Option } = Select;

class ModalEtapaOrdenProduccionPU extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    transiciones: [],
    protegida: false,
    esFinal: false,
    esRetrabajo: false,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      if (this.props.etapaId) {
        this.cargarEtapa();
      } else {
        this.formRef.current?.resetFields();
        this.setState({ transiciones: [], protegida: false, esFinal: false, esRetrabajo: false });
      }
    }
  }

  cargarEtapa = () => {
    this.setState({ loading: true });
    axios
      .post(
        "etapasOrdenProduccionPU/obtenerEtapa",
        { etapaId: this.props.etapaId, empresaId: this.props.empresaId, ...this.props.scope },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2 && res.data.etapa) {
          const etapa = res.data.etapa;
          this.formRef.current?.setFieldsValue({
            nombre: etapa.nombre,
            descripcion: etapa.descripcion,
            icono: etapa.icono,
            color: etapa.color || "#1890ff",
            configuracionTransicion: etapa.configuracionTransicion || {},
            tipoObjetivo: etapa.tipoObjetivo,
          });
          this.setState({
            protegida: etapa.protegida,
            esFinal: etapa.esFinal,
            esRetrabajo: !!etapa.esRetrabajo,
            transiciones: etapa.esFinal
              ? []
              : (etapa.transiciones || []).map((t) => ({
                  ...t,
                  etapaDestinoId: t.etapaDestinoId?._id || t.etapaDestinoId,
                })),
          });
        } else {
          MensajeError({ message: "No se pudieron cargar los datos de la etapa" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al cargar los datos de la etapa" });
      });
  };

  agregarTransicion = () => {
    this.setState((prev) => ({
      transiciones: [...prev.transiciones, { etapaDestinoId: null, etiqueta: "" }],
    }));
  };

  cambiarTransicion = (index, cambios) => {
    this.setState((prev) => ({
      transiciones: prev.transiciones.map((t, i) => (i === index ? { ...t, ...cambios } : t)),
    }));
  };

  eliminarTransicion = (index) => {
    this.setState((prev) => ({ transiciones: prev.transiciones.filter((_, i) => i !== index) }));
  };

  normColor = (color) => {
    if (!color) return null;
    if (typeof color === "string") return color;
    if (typeof color.toHexString === "function") return color.toHexString();
    return null;
  };

  onFinishFailed = (e) => ErrorItem(e);

  onFinish = (values) => {
    const transiciones = this.props.etapaId
      ? this.state.transiciones.filter((t) => t.etapaDestinoId).map((t, index) => ({ ...t, orden: index }))
      : [];

    this.setState({ loading: true });

    const url = this.props.etapaId ? "etapasOrdenProduccionPU/editarEtapa" : "etapasOrdenProduccionPU/agregarEtapa";
    const body = {
      ...values,
      tipoObjetivo: values.tipoObjetivo || null,
      esRetrabajo: this.state.esRetrabajo,
      empresaId: this.props.empresaId,
      ...this.props.scope,
      transiciones,
      ...(this.props.etapaId ? { etapaId: this.props.etapaId } : {}),
    };

    axios
      .post(url, body, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(this.props.etapaId ? "Etapa actualizada correctamente" : "Etapa agregada correctamente");
          this.props.cerrarModal(res.data.etapa?._id);
        } else {
          MensajeError({ message: res.data.error || "Error al guardar la etapa" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  render() {
    const etapasDisponibles = (this.props.etapasDisponibles || []).filter((e) => e._id !== this.props.etapaId);

    return (
      <ModalItem
        title={this.props.etapaId ? "Editar etapa" : "Agregar etapa"}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.props.cerrarModal()}
        width="70%"
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="ModalEtapaOrdenProduccionPU"
          layout
          bottom={
            <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <Row gutter={16} style={{ width: "100%" }}>
            <Col span={12}>
              <FormItem name="nombre" label="Nombre" required max={100} margin pattern>
                <InputItem placeholder="Nombre de la etapa" />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem name="descripcion" label="Descripción" margin pattern required>
                <InputItem placeholder="Descripción" />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem name="icono" label="Icono" margin tooltip="Para distinguir la etapa a simple vista en el dashboard.">
                <Select placeholder="Selecciona un icono" allowClear>
                  {OPCIONES_ICONO_ETAPA.map((nombreIcono) => {
                    const Icono = ICONOS_ETAPA[nombreIcono];
                    return (
                      <Option key={nombreIcono} value={nombreIcono}>
                        <Icono style={{ marginRight: 8 }} /> {nombreIcono.replace("Outlined", "")}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem name="color" label="Color" margin initialValue="#1890ff" getValueFromEvent={this.normColor} tooltip="Color con el que se va a ver esta etapa en el dashboard.">
                <ColorPicker disabledAlpha format="hex" size="middle" showText />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Etapa de retrabajo" margin specialLayoutSwitch tooltip="Al mover piezas a esta etapa se elige la matriz de retrabajo; luego se juntan con las de otras órdenes en una orden de retrabajo.">
                <SwitchItem checked={this.state.esRetrabajo} onChange={(esRetrabajo) => this.setState({ esRetrabajo })} />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                name="tipoObjetivo"
                label="Tipo de objetivo"
                margin
                tooltip="Cómo se evalúa el % esperado de esta etapa en los reportes. Mínimo: cumple si llegan al menos ese % de piezas (ej. Terminado). Máximo: cumple si no se pasa de ese % (ej. Scrap, Retrabajo, Re-proceso). Sin elegir: la etapa final es mínimo y las demás máximo."
              >
                <Select placeholder={`Automático (${this.state.esFinal ? "mínimo" : "máximo"})`} allowClear>
                  <Option value="minimo">Mínimo: llegar al menos al %</Option>
                  <Option value="maximo">Máximo: no pasarse del %</Option>
                </Select>
              </FormItem>
            </Col>
            {this.state.protegida && (
              <Col span={24}>
                <Alert
                  type="info"
                  showIcon
                  icon={<LockOutlined />}
                  message="Esta es una etapa fija del sistema (Pendiente o Terminado). Puedes editar su nombre, descripción y transiciones, pero no dejará de ser inicial/final."
                  style={{ marginBottom: 16 }}
                />
              </Col>
            )}

            <Col span={24}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>Qué pedir al SALIR de esta etapa</div>
              <div style={{ color: "#999", fontSize: 12, marginBottom: 8 }}>
                Se pide una sola vez por todo el lote que sale, sin importar a cuántos destinos se reparta.
              </div>
              <Row gutter={[16, 8]} style={{ marginBottom: 16 }}>
                <Col span={12}>
                  <FormItem name={["configuracionTransicion", "pedirLotes"]} label="Lotes/marbetes" margin specialLayoutSwitch valuePropName="checked" tooltip="Exige elegir de qué lote/marbete sale la materia prima con trazabilidad activada.">
                    <SwitchItem />
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem name={["configuracionTransicion", "pedirMaquinariaOperador"]} label="Maquinaria / operador" margin specialLayoutSwitch valuePropName="checked">
                    <SwitchItem />
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem name={["configuracionTransicion", "pedirMerma"]} label="Merma" margin specialLayoutSwitch valuePropName="checked" tooltip="Exige capturar cuánto se perdió y por qué, si hay merma.">
                    <SwitchItem />
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem name={["configuracionTransicion", "pedirTiempoTrabajo"]} label="Tiempo de trabajo" margin specialLayoutSwitch valuePropName="checked">
                    <SwitchItem />
                  </FormItem>
                </Col>
              </Row>

              <div style={{ fontWeight: 600, marginBottom: 4 }}>Qué pedir al ENTRAR a esta etapa</div>
              <Row gutter={[16, 8]} style={{ marginBottom: 16 }}>
                <Col span={12}>
                  <FormItem name={["configuracionTransicion", "pedirValidacionCalidad"]} label="Validación de calidad" margin specialLayoutSwitch valuePropName="checked" tooltip="Exige elegir un responsable (usuario) que firme con un comentario antes de dejar entrar piezas aquí.">
                    <SwitchItem />
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem name={["configuracionTransicion", "pedirComentarioEntrada"]} label="Comentario" margin specialLayoutSwitch valuePropName="checked" tooltip="Exige capturar un comentario al mover piezas hacia aquí.">
                    <SwitchItem />
                  </FormItem>
                </Col>
              </Row>
            </Col>

            {!this.props.etapaId ? (
              <Col span={24}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>Transiciones a otras etapas</div>
                <div style={{ color: "#999", fontSize: 12 }}>
                  Primero guarda la etapa; después ábrela de nuevo para agregarle sus transiciones.
                </div>
              </Col>
            ) : this.state.esFinal ? (
              <Col span={24}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>Transiciones a otras etapas</div>
                <div style={{ color: "#999", fontSize: 12 }}>
                  "Terminado" es el final del flujo: no puede tener transiciones a otras etapas.
                </div>
              </Col>
            ) : (
              <Col span={24}>
                <div style={{ fontWeight: 600, marginBottom: 8 }}>Transiciones a otras etapas</div>
                {this.state.transiciones.map((transicion, index) => (
                  <Row key={index} gutter={8} align="middle" style={{ marginBottom: 8 }}>
                    <Col span={10}>
                      <Select
                        placeholder="Etapa destino"
                        style={{ width: "100%" }}
                        value={transicion.etapaDestinoId || undefined}
                        onChange={(value) => this.cambiarTransicion(index, { etapaDestinoId: value })}
                      >
                        {etapasDisponibles.map((etapa) => (
                          <Option key={etapa._id} value={etapa._id}>
                            {etapa.nombre}
                          </Option>
                        ))}
                      </Select>
                    </Col>
                    <Col span={12}>
                      <InputItem
                        placeholder="Etiqueta (ej. Aprobado, Retrabajo...)"
                        value={transicion.etiqueta}
                        onChange={(e) => this.cambiarTransicion(index, { etiqueta: e.target.value })}
                      />
                    </Col>
                    <Col span={2}>
                      <DeleteOutlined onClick={() => this.eliminarTransicion(index)} />
                    </Col>
                  </Row>
                ))}
                <ButtonItem icon={<PlusOutlined />} onClick={this.agregarTransicion} size="small">
                  Agregar transición
                </ButtonItem>
              </Col>
            )}
          </Row>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalEtapaOrdenProduccionPU);
